module.exports = __webpack_public_path__ + "img/uav3.034d5b66.png";